import { onBeforeUnmount, onMounted, useBlokkli } from "#imports";
export default function(cb) {
  const { dropAreas } = useBlokkli();
  onMounted(() => {
    dropAreas.add(cb);
  });
  onBeforeUnmount(() => {
    dropAreas.remove(cb);
  });
}
